import FormLayout from './form-layout.vue';

export default FormLayout;



// WEBPACK FOOTER //
// ./src/components/form-layout/index.js